'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.waitForAttach = undefined;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _timeout = require('q/js/lib/timeout');

var _timeout2 = _interopRequireDefault(_timeout);

var _defaults = require('../constants/defaults');

var _channelStates = require('../constants/channelStates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @description Wait until a channel is attached
 *
 * @param {Realtime.Channels} channels ably channel collection
 * @param {String} channelId channel id
 * @returns {Promise} Promise that resolves when the channel is attached
 */
var waitForAttach = exports.waitForAttach = function waitForAttach(channels, channelId) {
  return (0, _timeout2.default)(new _q2.default.Promise(function (resolve) {
    var channel = channels.get(channelId);

    if (channel.state === _channelStates.ATTACHED) {
      resolve();
    } else {
      channel.once(_channelStates.ATTACHED, resolve);
    }
  }), _defaults.PROMISE_TIMEOUT_MS, 'PubSub wait for attach timeout');
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/ably/api-wrappers/waitForAttach.js
// module id = 784
// module chunks = 2 3